export const environment = {
  production: true,
  api_url: 'https://noobav3.azurewebsites.net/',
  legacy_api_url: 'https://noobav2.azurewebsites.net/',
  majorVersion: '0',
  minorVersion: '0',
  commitNumber: '415'
};
